<template>
<div>
  <div class="manage-employee-title">
    Organization Chart > จัดการพนักงาน
  </div>
  <div class="text-center">
    <v-row>
    <v-col cols="12" sm="12" md="6" lg="4" class="pb-0">
      <span class="filter-title-textfield">รหัสพนักงาน</span>
      <v-text-field
        v-model="employeeId"
        chips
        outlined
        label="ค้นหา รหัสพนักงาน"
        class="mt-2"
        dense
      >
      </v-text-field>
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="4" class="pb-0">
      <span class="filter-title-textfield">ชื่อ-สกุล</span>
      <v-text-field
        v-model="employeeName"
        outlined
        label="ชื่อสายงาน"
        class="mt-2"
        dense
      >
      </v-text-field>
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="4" class="pb-0">
      <span class="filter-title-textfield">ชื่อย่อบริษัท</span>
      <v-select
        v-model="companyShortName"
        :items="itemCompanyName"
        outlined
        label="ค้นหา ชื่อย่อบริษัท"
        class="mt-2"
        multiple
        dense
      >
      <template #selection="{ item }">
        <v-chip color="#0370B7 !important">
          <span class="filter-chip_department">{{item}}</span>
        </v-chip>
      </template>
      </v-select>
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="4" class="pt-0">
      <span class="filter-title-textfield">E-mail</span>
      <v-text-field
        v-model="email"
        outlined
        label="ค้นหา E-mail"
        class="mt-2"
        dense
      >
      </v-text-field>
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="4" class="pt-0 d-flex align-end">
      <v-row class="pl-3 pr-3" style="margin-bottom: 14px;">
        <v-btn color="warning" class="mr-5" style="min-height: 38px;" @click="searchFilterData()">ค้นหา</v-btn>
        <v-btn color="error" style="min-height: 38px;" @click="resetFilterData()">ล้างข้อมูล</v-btn>
      </v-row>
    </v-col>
  </v-row>
  </div>
      <v-data-table
      :headers="headers"
      :items="desserts"
      class="elevation-1"
      item-key="_id"
      group-by="NameTh"
      disable-sort
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <!-- <v-toolbar-title>Employee</v-toolbar-title> -->
          <!-- <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider> -->
          <v-spacer></v-spacer>
          <v-btn class="ma-2" tile color="success" @click="openDialogCreate()">
            <v-icon left>mdi-plus</v-icon> Create
          </v-btn>
          <v-btn
            color="blue-grey"
            class="ma-2 white--text"
          >
            Import
            <v-icon right dark>mdi-cloud-upload</v-icon>
          </v-btn>
          <v-btn
            color="blue-grey"
            class="ma-2 white--text"
          >
            Export
            <v-icon right dark>mdi-cloud-download</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
      <v-btn
        rounded
        color="#2196F3"
        dark
        class="mt-3 mb-3"
        @click="openDialogEdit(item)"
      >
      <v-icon left dark color="white" small>fa-edit</v-icon>
      Edit
      </v-btn>
      <!-- <v-btn class="ma-2" outlined x-small fab color="red" @click="deleteItem(item)">
        <v-icon>mdi-delete</v-icon>
      </v-btn> -->
    </template>
    </v-data-table>
    <DialogCreateEmployee/>
    <DialogEditEmployee/>
</div>
</template>
<script>
import { EventBus } from '@/EventBus'
import DialogCreateEmployee from './dialogCreateEmployee'
import DialogEditEmployee from './dialogEditEmployee'
export default {
  components: {
    DialogCreateEmployee, DialogEditEmployee
  },
  data () {
    return {
      expanded: [],
      singleExpand: false,
      dialog: false,
      dialogCreate: false,
      tab: null,
      textTitle: 'Create New',
      e1: 1,
      steps: 2,
      employeeId: '',
      employeeName: '',
      companyShortName: [],
      email: '',
      headers: [
        {
          text: 'No.',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ชื่อ-สกุล', value: 'NameTh' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'สายงาน', value: 'orgChartName' },
        { text: 'สายบังคับบัญชา', value: 'orgChartHeader' },
        { text: 'ชื่อย่อบริษัท', value: 'companyName' },
        { text: 'E-mail', value: 'emailOneId' },
        { text: 'Actions', value: 'actions', sortable: false },
        { text: '', value: 'data-table-expand' }
      ],
      desserts: [
        {
          id: '1',
          employeeId: '61340',
          NameTh: 'นายสิทธิกร คำผาลา',
          companyName: 'INET',
          orgChartName: 'INET',
          emailOneId: 'test@hotmail.com'
        },
        {
          id: '2',
          employeeId: '61340',
          name: 'นายสิทธิกร คำผาลา',
          nameCompanySh: 'OGS',
          email: 'test@hotmail.com'
        }
      ],
      itemCompanyName: [],
      itemPosition: []
    }
  },
  mounted () {
    EventBus.$on('closeDialogEdit', this.closeDialogEdit)
    // EventBus.$on('closedialogcreate', this.closeDialogCreate)
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.getEmployeeLists()
    this.getSelectCompany()
  },
  watch: {
    steps (val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    }
  },
  methods: {
    nextStep (n) {
      if (n === this.steps) {
        this.e1 = 1
      } else {
        this.e1 = n + 1
      }
    },
    async getSelectCompany () {
      await this.axios({
        method: 'get',
        url: `${this.api}/api/vMonk/users/selectUsers`
      }).then((response) => {
        // console.log('Get Select List', response.data.result)
        this.itemCompanyName = response.data.result.companyNameSelect
        this.itemPosition = response.data.result.positionSelect
      }).catch(e => {
        console.log(e)
      })
    },
    async getEmployeeLists () {
      const temp = []
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/users/getUsers`,
        data: {
          employeeId: this.employeeId,
          name: this.employeeName,
          companyName: [this.companyShortNameEng],
          position: '',
          orgChartName: '',
          orgChartHeader: '',
          limit: 50,
          page: 1
          // createAt: this.createAt,
          // updateAt: this.updateAt
        }
      }).then((response) => {
        // console.log('Data', response.data)
        if (response.data.success) {
          if (response.data.result.length) {
            response.data.result.map((el, index) => {
              temp.push({
                no: index + 1,
                ...el
              })
            })
            this.desserts = temp
          }
        } else {
          // console.log(response)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    searchFilterData () {
      this.getEmployeeLists()
    },
    resetFilterData () {
      this.employeeId = ''
      this.employeeName = ''
      this.companyShortName = []
      this.getEmployeeLists()
    },
    editCompany (value) {
      this.textTitle = ''
      // this.dialogCreate = true
      this.textTitle = value
    },
    openDialogCreate (value) {
      this.dialogCreate = true
      // console.log('Value', value)
      EventBus.$emit('opendialogcreate', this.dialogCreate, value)
    },
    openDialogEdit (value) {
      this.dialogEdit = true
      // console.log('Value Edit', value)
      EventBus.$emit('opendialogedit', value)
    },
    // closeDialogCreate (value) {
    //   this.dialogCreate = value
    // },
    closeDialog () {
      this.textTitle = 'Create New'
      this.dialogCreate = false
    }
  }
}
</script>

<style scoped>
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.manage-employee-title {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1.5rem;
}
</style>
